<template>
  <span>
    <v-dialog
      v-model="showCounterParametersData"
      width="1100px"
    >
      <counter-parameters-data
        :counter-id="selectedCounterData.counter_id"
        :is-open="showCounterParametersData"
        @close="closeCounterParametersData"
      />
    </v-dialog>

    <v-dialog
      v-model="showCounterHistory"
      width="800px"
    >
      <counter-history
        v-if="showCounterHistory"
        :counter-data="selectedCounterData"
        @close="closeCounterHistory"
      />
    </v-dialog>

    <counter-new
      v-if="adding"
      @cancel="cancelAdding"
      @added="counterAdded"
    />

    <counter-edit
      v-else-if="editing"
      :counter-data="selectedCounterData"
      @cancel="cancelEditing"
      @edited="counterEdited"
      @editError="editCounterError"
    />

    <v-layout
      v-else-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>

    <div
      v-show="!adding && !editing && !firstLoading"
    >
      <v-card class="counters-card">
        <v-card-title
          v-if="showSuccessMsg"
          class="success-message"
          :class="{ 'success-message-hide': !showSuccess}"
        >
          <div class="headline success-message-text"><i class="far fa-check-circle" /> Счетчик успешно добавлен</div>
        </v-card-title>
        <v-card-title
          v-if="showErrorMsg"
          class="error-message"
          :class="{ 'error-message-hide': !showError}"
        >
          <div class="headline success-message-text"><i class="far fa-times-circle" /> {{ errorMsg }}</div>
        </v-card-title>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Поиск по номеру счетчика"
            single-line
            hide-details
          />
          <v-spacer />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          fixed-header
          dense
          no-data-text="Нет данных для отображения"
          :footer-props="{
            itemsPerPageText: 'Число счетчиков на странице',
            itemsPerPageOptions: [25, 50]
          }"
        >
          <tr
            slot="item"
            slot-scope="props"
          >
            <td class="text-right">{{ props.item.serial_num }}</td>
            <td class="text-right">{{ props.item.model.name }}</td>
            <td class="text-right">{{ props.item.coeff }}</td>
            <td class="text-right">{{ props.item.coeff_voltage }}</td>
            <td class="text-right">
              <router-link
                :to="'/points/' + props.item.point_id + '/counters'"
                title="Переход в раздел Точки учета"
              >{{ props.item.point_number }}</router-link>
              <a
                v-if="props.item.point_id"
                class="external-link"
                target="_blank"
                :href="'/points/' + props.item.point_id + '/counters'"
                title="Открыть раздел Точки учета, в новой вкладке(окне)"
              ><v-icon>mdi-open-in-new</v-icon></a>
            </td>
            <td class="justify-center">
              <span class="action-btns">
                <v-btn
                  icon
                  class="mt-1"
                  title="Информация"
                  @click="getCounterParametersData(props.item)"
                >
                  <v-icon>info</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mt-1"
                  title="Редактировать"
                  @click="editCounter(props.item)"
                >
                  <v-icon color="grey">edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mt-1"
                  title="История операций по счётчику"
                  @click="counterHistory(props.item)"
                >
                  <v-icon color="grey darken-1">mdi-history</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="mt-1"
                  title="Удалить"
                  @click="deleteCounter(props.item)"
                >
                  <v-icon color="red">delete</v-icon>
                </v-btn>
              </span>
            </td>
          </tr>
        </v-data-table>
      </v-card>
    </div>
  </span>
</template>

<script>
const API_URL = 'counters'
import CounterNew from './CounterNew.vue'
import CounterEdit from './CounterEdit.vue'
import CounterHistory from './CounterHistory.vue'
import CounterParametersData from './CounterParametersData'

export default {
  name: 'Counters',
  components: {
    CounterNew,
    CounterEdit,
    CounterHistory,
    CounterParametersData
  },
  data () {
    return {
      showCounterParametersData: false,
      search: '',
      items: [],
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [
        {
          text: 'Номер счетчика',
          align: 'right',
          sortable: false,
          value: 'serial_num'
        },
        {
          text: 'Модель',
          align: 'right',
          sortable: false,
          value: 'model'
        },
        {
          text: 'Коэф. трансформации тока',
          align: 'right',
          sortable: false,
          value: 'coeff'
        },
        {
          text: 'Коэф. трансформации напряжения',
          align: 'right',
          sortable: false,
          value: 'coeff_voltage'
        },
        {
          text: 'Номер Точки учёта',
          align: 'right',
          sortable: false,
          value: 'point_number'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'actions'
        }
      ],
      adding: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      selectedCounterData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      showCounterHistory: false,
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getCountersApiTimer()
      },
      deep: true
    },
    search () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.options.page = 1
        this.getCountersApiTimer()
      }, 500)
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  methods: {
    getCountersApi () {
      this.loading = true
      this.axios.get(`/api/${API_URL}/?per_page=${this.options.itemsPerPage}&page=${this.options.page}&search=${this.search}`)
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.firstLoading = false
          this.loading = false
        })
    },
    getCountersApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getCountersApi()
      }, 100)
    },
    showErrorMessage (msg) {
      this.errorMsg = msg
      this.showError = true
      this.showErrorMsg = true
      setTimeout(() => {
        this.showError = false
      }, 4000)
      setTimeout(() => {
        this.showErrorMsg = false
      }, 4350)
    },
    deleteCounterApi (item) {
      this.axios.delete(`/api/${API_URL}/${item.counter_id}/`)
        .then((response) => {
          this.items.splice(
            this.items.indexOf(item), 1
          )
          clearTimeout(this.deleteTimer)
          this.deleteTimer = setTimeout(() => {
            this.items.length || this.options.page === 1 || this.options.page--
            this.getCountersApiTimer()
          }, 1000)
        })
        .catch((err) => {
          this.showErrorMessage(err.response.data)
          console.log(err)
        })
    },
    addCounter () {
      this.adding = true
    },
    cancelAdding () {
      this.adding = false
    },
    counterAdded () {
      this.getCountersApiTimer()
      this.adding = false
      this.showSuccess = true
      this.showSuccessMsg = true
      setTimeout(() => {
        this.showSuccess = false
      }, 3000)
      setTimeout(() => {
        this.showSuccessMsg = false
      }, 3350)
    },
    editCounter (item) {
      this.selectedCounterData = item
      this.editing = true
    },
    counterEdited (counter) {
      Object.assign(this.selectedCounterData, counter)
      this.editing = false
    },
    cancelEditing () {
      this.editing = false
    },
    editCounterError (msg) {
      this.editing = false
      this.showErrorMessage(msg)
    },
    counterHistory (item) {
      this.selectedCounterData = item
      this.showCounterHistory = true
    },
    closeCounterHistory () {
      this.showCounterHistory = false
    },
    deleteCounter (item) {
      if (confirm('Вы действительно хотите удалить эту строку?')) {
        this.deleteCounterApi(item)
      }
    },
    getCounterParametersData (counter) {
      this.selectedCounterData = counter
      this.showCounterParametersData = true
    },
    closeCounterParametersData () {
      this.showCounterParametersData = false
    }
  }
}
</script>

<style lang="scss">
  .success-message {
    text-align: center;
    background-color: #56bb60;
  }
  .success-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .success-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }
  .error-message {
    text-align: center;
    background-color: #f91100;
  }
  .error-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .error-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }
  .v-btn--floating .v-btn__content {
    height: inherit;
  }
  .v-card.counters-card {
    position: unset;
    .v-data-table {
      position: absolute;
      height: calc(100% - 88px);
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
  .action-btns {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/spa/counters/Counters.vue